<template>
  <div>
    <div class="card">
      <div class="card-header" id="headingAlert">
        <h5>Current Steps</h5>
        <router-link
          :to="{
            name: 'AlertStepAdd',
            params: {
              alert_id: alert_id,
              alert_step_order_type_id: alert_step_order_type_id,
            },
          }"
          class="btn btn-hub-primary"
          v-if="!preview_only"
        >
          <i class="fa fa-edit" aria-hidden="true"></i> Add Step
        </router-link>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  data-toggle="tab"
                  href="#main"
                  role="tab"
                  @click="changeOrderType(1)"
                  >Main</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  href="#postAlert"
                  role="tab"
                  @click="changeOrderType(2)"
                  >Post-Alert</a
                >
              </li>
            </ul>
            <br />
            <div class="tab-content">
              <div class="tab-pane fade show active" id="main" role="tabpanel">
                <table class="table table-striped">
                  <thead class="bg-hub-primary text-white">
                    <tr>
                      <th>Step</th>
                      <th>Type</th>
                      <th>Sound/Visual/Command/To Step</th>
                      <th v-show="!preview_only">Duration</th>
                      <th v-show="!preview_only">Manage</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="alert_step in pre_alert_steps"
                      :key="alert_step.alert_step_id"
                    >
                      <td>{{ alert_step.order }}</td>
                      <td>{{ alert_step.alert_step_command_type.name }}</td>

                      <td v-if="alert_step.alert_step_command_type_id === 1">
                        {{ alert_step.sound.filename }} <br />
                        ({{ alert_step.zone.name }})
                      </td>
                      <td
                        v-else-if="
                          [7, 8].includes(alert_step.alert_step_command_type_id)
                        "
                      >
                        {{ alert_step.advanced_visual.name }} <br />
                        ({{ alert_step.zone.name }})
                      </td>
                      <td v-else-if="alert_step.alert_step_command_type_id === 2">
                        {{ alert_step.barix_command }}
                      </td>
                      <td v-else-if="alert_step.alert_step_command_type_id === 4">
                        {{ alert_step.to_alert_step.order }}
                      </td>
                      <td v-else>N/A</td>

                      <td v-if="alert_step.alert_step_command_type_id === 1" v-show="!preview_only">
                        {{ alert_step.sound.length }} second(s)
                      </td>
                      <td
                        v-else-if="alert_step.alert_step_command_type_id === 3"
                        v-show="!preview_only"
                      >
                        {{ alert_step.sleep_duration }} second(s)
                      </td>
                      <td v-show="!preview_only" v-else>N/A</td>

                      <td v-if="!preview_only">
                        <div class="dropdown">
                          <button
                            class="btn btn-light dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
                          </button>
                          <div
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <button class="dropdown-item" @click="editAlertStep(alert_step.alert_step_id, alert_step.order)">
                              <i class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i>&nbsp;Edit
                            </button>
                            <a
                              class="dropdown-item"
                              href="#"
                              onclick="return false"
                              @click="deleteAlertStep(alert_step)"
                            >
                              <i
                                class="fa fa-trash fa-fw"
                                aria-hidden="true"
                              ></i
                              >&nbsp;Delete
                            </a>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="col middle-btn-col">
                          <a
                            class="btn btn-sm btn-block btn-light"
                            @click="
                              reorderAlertStep(alert_step.alert_step_id, 'up')
                            "
                          >
                            <i
                              class="fa fa-arrow-up fa-fw"
                              aria-hidden="true"
                            ></i>
                          </a>
                          <a
                            class="btn btn-sm btn-block btn-light"
                            @click="
                              reorderAlertStep(alert_step.alert_step_id, 'down')
                            "
                          >
                            <i
                              class="fa fa-arrow-down fa-fw"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Last</td>
                      <td>End <br> (Go to Post-Alert)</td>
                      <td>N/A</td>
                      <td v-show="!preview_only">N/A</td>
                      <td v-show="!preview_only">N/A</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="tab-pane fade" id="postAlert" role="tabpanel">
                <table class="table table-striped">
                  <thead class="bg-hub-primary text-white">
                    <tr>
                      <th>Step</th>
                      <th>Type</th>
                      <th>Sound/Visual/Command/To Step</th>
                      <th v-show="!preview_only">Duration</th>
                      <th v-show="!preview_only">Manage</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="alert_step in post_alert_steps"
                      :key="alert_step.alert_step_id"
                    >
                      <td>{{ alert_step.order }}</td>
                      <td>{{ alert_step.alert_step_command_type.name }}</td>

                      <td v-if="alert_step.alert_step_command_type_id === 1">
                        {{ alert_step.sound.filename }} <br />
                        ({{ alert_step.zone.name }})
                      </td>
                      <td
                        v-else-if="
                          [7, 8].includes(alert_step.alert_step_command_type_id)
                        "
                      >
                        {{ alert_step.advanced_visual.name }} <br />
                        ({{ alert_step.zone.name }})
                      </td>
                      <td v-else-if="alert_step.alert_step_command_type_id === 2">
                        {{ alert_step.barix_command }}
                      </td>
                      <td v-else-if="alert_step.alert_step_command_type_id === 4">
                        {{ alert_step.to_alert_step.order }}
                      </td>
                      <td v-else>N/A</td>

                      <td v-if="alert_step.alert_step_command_type_id === 1" v-show="!preview_only">
                        {{ alert_step.sound.length }} second(s)
                      </td>
                      <td
                        v-else-if="alert_step.alert_step_command_type_id === 3"
                        v-show="!preview_only"
                      >
                        {{ alert_step.sleep_duration }} second(s)
                      </td>
                      <td v-show="!preview_only" v-else>N/A</td>

                      <td v-if="!preview_only">
                        <div class="dropdown">
                          <button
                            class="btn btn-light dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
                          </button>
                          <div
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <button class="dropdown-item" @click="editAlertStep(alert_step.alert_step_id, alert_step.order)">
                              <i class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i>&nbsp;Edit
                            </button>
                            <a
                              class="dropdown-item"
                              href="#"
                              onclick="return false"
                              @click="deleteAlertStep(alert_step)"
                            >
                              <i
                                class="fa fa-trash fa-fw"
                                aria-hidden="true"
                              ></i
                              >&nbsp;Delete
                            </a>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="col middle-btn-col">
                          <a
                            class="btn btn-sm btn-block btn-light"
                            @click="
                              reorderAlertStep(alert_step.alert_step_id, 'up')
                            "
                          >
                            <i
                              class="fa fa-arrow-up fa-fw"
                              aria-hidden="true"
                            ></i>
                          </a>
                          <a
                            class="btn btn-sm btn-block btn-light"
                            @click="
                              reorderAlertStep(alert_step.alert_step_id, 'down')
                            "
                          >
                            <i
                              class="fa fa-arrow-down fa-fw"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Last</td>
                      <td>End <br> (Alert will end)</td>
                      <td>N/A</td>
                      <td v-show="!preview_only">N/A</td>
                      <td v-show="!preview_only"></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal :modal_id="'editAlertStepModal'">
      <template v-slot:title>
        {{ modal_title }}
      </template>
      <template v-slot:body>
        <EditAlertStep :alert_id="alert_id" :alert_step_id="alert_step_id_to_edit"></EditAlertStep>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Modal from '../Modal'
import EditAlertStep from '../../views/Alert/EditAlertStep'

export default {
  props: { alert_id: { type: [Number, String] }, preview_only: { type: Boolean, default: false } },
  data: function () {
    return {
      alert_step_order_type_id: 1,
      modal_type: 'EditAlertStep',
      alert_step_id_to_edit: 0,
      alert_step_order_to_edit: 0
    }
  },
  computed: {
    ...mapGetters({
      alert: 'singleAlert',
      alert_steps: 'allAlertSteps'
    }),
    pre_alert_steps: function () {
      return this.alert_steps.filter(
        (alertStep) => alertStep.alert_step_order_type_id === 1
      )
    },
    post_alert_steps: function () {
      return this.alert_steps.filter(
        (alertStep) => alertStep.alert_step_order_type_id === 2
      )
    },
    modal_title: function () {
      return `Edit Step ${this.alert_step_order_to_edit} in ${this.alert.name}`
    }
  },
  components: { Modal, EditAlertStep },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getAlert', this.alert_id)
    this.$store.dispatch('getAlertSteps', this.alert_id)
  },
  methods: {
    ...mapActions(['deleteAlertStep', 'executeAlert']),
    editAlertStep (alertStepId, alertStepOrder) {
      this.alert_step_id_to_edit = alertStepId
      this.alert_step_order_to_edit = alertStepOrder
      $('#editAlertStepModal').modal('show') // eslint-disable-line
    },
    reorderAlertStep (alertStepId, direction) {
      let params = {}

      params.alert_step_id = alertStepId
      params.alert_id = this.alert_id
      params.direction = direction

      this.$store.dispatch('reorderAlertStep', params)
    },
    changeOrderType (orderTypeId) {
      this.alert_step_order_type_id = orderTypeId
    }
  }
}
</script>

<style scoped>
</style>
